import { Data2, QuickFormModal } from "../../../data-types"
import { ModalId, useUIState } from "../../../ui"
import { AddressFormLoader } from "../address-form-modal/loader"

type Props = {
    onSubmit: (data: Data2) => void
}

export const AddressQuickFormModal = (props: Props) => {
    const { onSubmit } = props

    const { openedModal } = useUIState()

    return (
        <QuickFormModal title="Crear Dirección" widthSize="l">
            {openedModal === ModalId.QUICK_FORM ? (
                <AddressFormLoader onSubmit={onSubmit} />
            ) : <></>}
        </QuickFormModal>
    )
}
